import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Upload, Button, message } from 'antd';
import {
    FileTextOutlined,
    UploadOutlined,
    PlusOutlined,
    DeleteOutlined,
    CloseOutlined,
    EditOutlined,
} from '@ant-design/icons';
import { Button as MuiButton } from '@material-ui/core';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import YFinput from '../elements/YFInput';
import { objectToFormData } from 'object-to-formdata';
// import useApplicationSession from "../../session/UserSession";
import {
    submitDeclaration,
    updateDeclaration,
    addRelationship,
    updateRelationship,
    deleteRelationship,
    addLoan,
    updateLoan,
    deleteLoan,
    updateLivingExpense,
} from '../../api';
import profileStore from './profileStore';
// import Loading from "../../components/Loading";
// const { Option } = Select;

const EDIT_BANK_STATEMENT = 1;
const EDIT_LOAN = 2;
const EDIT_MONTHLY_EXPENSE = 3;
const EDIT_CONTACT_DETAIL = 4;

const DeclarationForm = ({ token, value }) => {
    const { register, handleSubmit, control, errors, setError, reset, setValue } = useForm({
        defaultValues: {
            statement: value.statement,
            living_expense:
                value.livingExpense === null
                    ? { general_living: '', rent: '', utilities: '', others: '' }
                    : value.livingExpense,
            loans: [
                {
                    loan_id: undefined,
                    loan_type: undefined,
                    lender: undefined,
                    current_payment: undefined,
                    monthly_payment: undefined,
                },
            ],
            relationship:
                value?.relationships?.length === 0
                    ? [
                          {
                              fullname: '',
                              address: '',
                              contact_number: '',
                              relationship_type: undefined,
                          },
                          {
                              fullname: '',
                              address: '',
                              contact_number: '',
                              relationship_type: undefined,
                          },
                      ]
                    : value?.relationships,
        },
    });

    const [frontImage] = useState([]);
    const [backImage] = useState([]);
    const [disableBankStatement, setDisableBankStatement] = useState(false);
    const [disableCreditStatement, setDisableCreditStatement] = useState(false);
    const [disableLoanAdd, setDisableLoanAdd] = useState(false);
    const [editBankStatement, setEditBackStatement] = useState(false);
    const [editLoan, setEditLoan] = useState(false);
    const [editMonthlyExpense, setEditMonthlyEpense] = useState(false);
    const [editContactDetail, setEditContactDetail] = useState(false);

    const loanFieldArray = useFieldArray({
        control,
        name: 'loans',
    });
    const contactDetailFieldArray = useFieldArray({
        control,
        name: 'relationship',
    });

    useEffect(() => {
        if (value.statement === null) {
            setEditBackStatement(true);
        } else {
            setEditBackStatement(false);
        }

        if (value?.loans?.length === 0) {
            setEditLoan(true);
        } else {
            setEditLoan(false);
        }
        if (value?.livingExpense === null) {
            setEditMonthlyEpense(true);
        } else {
            setEditMonthlyEpense(false);
        }

        if (value?.relationships?.length === 0) {
            setEditContactDetail(true);
        } else {
            setEditContactDetail(false);
        }

        if (value?.loans?.length !== 0 && value?.livingExpense !== null && value?.relationships?.length !== 0) {
            value.loans.map((loan) => {
                loan.loan_id = loan.id;
                return loan;
            });
            value.relationships.map((relation) => {
                relation.relationship_id = relation.id;
                return relation;
            });
            reset({
                loans: value.loans,
                living_expense: value.livingExpense,
                relationship: value.relationships,
            });
        }
        setValue('bank_statement', value?.statement?.bank_statement);
        setValue('card_statement', value?.statement?.bank_statement);
    }, [value, setValue, reset]);

    const bankStatementPickerProps = {
        listType: 'picture',
        onRemove: () => {
            setDisableBankStatement(false);
        },
        beforeUpload: (file) => {
            setDisableBankStatement(true);
            return false;
        },
        frontImage,
    };
    const creditStatementPickerProps = {
        listType: 'picture',
        onRemove: () => {
            setDisableCreditStatement(false);
        },
        beforeUpload: (file) => {
            setDisableCreditStatement(true);
            return false;
        },
        backImage,
    };

    const onSubmit = (data) => {
        const isCreate = editBankStatement && editLoan && editContactDetail && editMonthlyExpense;
        if (isCreate) {
            // for new user
            if (data.relationship.length >= 2) {
                const options = {
                    indices: true,
                    nullsAsUndefineds: false,
                    booleansAsIntegers: false,
                };
                const formTest = objectToFormData(data, options);
                submitDeclaration({ token: token, request: formTest })
                    .then((response) => {
                        message.success(response?.data?.message);
                        profileStore.reload(token);
                    })
                    .catch((error) => {
                        if (error) {
                        }
                    });
            } else {
                setError('relationship', 'notMatch', 'Please enter two or more contact person.');
            }
        } else {
            // old user update for eacth section
            if (editBankStatement) {
                const form = new FormData();
                form.append('_method', 'PUT');
                const bank_statement = data.bank_statement;
                const card_statement = data.card_statement;
                if (bank_statement !== undefined) {
                    form.append('bank_statement', data.bank_statement);
                }
                if (card_statement !== undefined) {
                    form.append('card_statement', data.card_statement);
                }

                updateDeclaration({
                    token: token,
                    id: value?.statement?.personal_declaration_id,
                    request: form,
                })
                    .then((response) => {
                        message.success(response?.message);
                        setEditBackStatement(false);
                        profileStore.reload(token);
                    })
                    .catch((error) => {
                        if (error) {
                        }
                    });
            }

            if (editLoan) {
                const loans = data?.loans;
                const startIndex = value.loans.length; // origianl value
                const newRequest = [];
                for (let index = startIndex; index < loans.length; index++) {
                    const loan = loans[index];
                    loan.personal_declaration_id = value.statement.personal_declaration_id;
                    newRequest.push(loan);
                }

                if (newRequest.length > 0) {
                    Promise.all(
                        newRequest.map((loan) => {
                            return addLoan({ token: token, request: loan });
                        })
                    )
                        .then((response) => {
                            setEditLoan(false);
                            message.success(response[0]?.message);
                            profileStore.reload(token);
                        })
                        .catch((error) => {
                            if (error) {
                            }
                        });
                } else {
                    const requests = [];
                    for (let index = 0; index < loans.length; index++) {
                        const loan = loans[index];
                        loan.id = value.loans[index].id;
                        requests.push(loan);
                    }
                    Promise.all(
                        requests.map((loan) => {
                            loan.personal_declaration_id = value.statement.personal_declaration_id;
                            return updateLoan({ token, id: loan.id, request: loan });
                        })
                    ).then((response) => {
                        profileStore.reload(token);
                        message.success(response[0]?.message);
                    });
                }
            }

            if (editMonthlyExpense) {
                const request = {
                    token: token,
                    id: value.livingExpense?.id,
                    request: data.living_expense,
                };
                updateLivingExpense(request)
                    .then((response) => {
                        setEditMonthlyEpense(false);
                        message.success(response?.data?.message);
                        profileStore.reload(token);
                    })
                    .catch((error) => {
                        if (error) {
                        }
                    });
            }

            if (editContactDetail) {
                const relationship = data?.relationship;
                const startIndex = value.relationships.length;
                const newRelationship = [];

                for (let index = startIndex; index < relationship.length; index++) {
                    const item = relationship[index];
                    item.personal_declaration_id = value.statement.personal_declaration_id;
                    newRelationship.push(item);
                }

                if (newRelationship.length > 0) {
                    //addnew relationship
                    Promise.all(
                        newRelationship.map((relationship) => addRelationship({ token: token, request: relationship }))
                    )
                        .then((response) => {
                            message.success(response?.data?.message);
                            setEditContactDetail(false);
                            profileStore.reload(token);
                        })
                        .catch((error) => {
                            if (error) {
                            }
                        });
                } else {
                    //update relationship

                    const requests = [];
                    for (let index = 0; index < relationship.length; index++) {
                        const item = relationship[index];
                        item.id = value.relationships[index].id;
                        requests.push(item);
                    }
                    Promise.all(
                        requests.map((relationship) => {
                            relationship.personal_declaration_id = value.statement.personal_declaration_id;
                            return updateRelationship({
                                token,
                                id: relationship.id,
                                request: relationship,
                            });
                        })
                    ).then((response) => {
                        profileStore.reload(token);
                        message.success(response[0]?.message);
                    });
                }
            }
        }
    };

    useEffect(() => {
        if (loanFieldArray.fields.length >= 6) {
            setDisableLoanAdd(true);
        } else {
            setDisableLoanAdd(false);
        }
    }, [loanFieldArray.fields]);

    const handleEdit = (type) => {
        switch (type) {
            case EDIT_BANK_STATEMENT:
                setEditBackStatement(!editBankStatement);
                break;
            case EDIT_LOAN:
                setEditLoan(!editLoan);
                break;
            case EDIT_MONTHLY_EXPENSE:
                setEditMonthlyEpense(!editMonthlyExpense);
                break;
            case EDIT_CONTACT_DETAIL:
                setEditContactDetail(!editContactDetail);
                break;

            default:
                break;
        }
    };

    return (
        <form className="payment-information-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="payment-information-label-container">
                <FileTextOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                <h4 className="payment-information-label">Declaration</h4>
                {value.statement !== null && (
                    <Button
                        id="edit-bank"
                        style={{ float: 'right' }}
                        type="default"
                        icon={editBankStatement ? <CloseOutlined /> : <EditOutlined />}
                        size="middle"
                        onClick={() => handleEdit(EDIT_BANK_STATEMENT)}
                    />
                )}
            </div>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <label style={{ display: 'block' }}>Bank Statement</label>
                    {editBankStatement && (
                        <Controller
                            name="bank_statement"
                            as={
                                <Upload {...bankStatementPickerProps} accept="image/*,.pdf" multiple={false}>
                                    <Button disabled={disableBankStatement}>
                                        <UploadOutlined /> Select Bank Statement
                                    </Button>
                                </Upload>
                            }
                            control={control}
                            onChange={([data]) => {
                                return data.file;
                            }}
                            rules={{ required: value.statement === null ? true : false }}
                        />
                    )}

                    {errors.bank_statement && <span className="formFieldError">Please select bank statement.</span>}
                    {value?.statement !== null && [
                        value?.statement?.bank_statement.substr(
                            value?.statement?.bank_statement.lastIndexOf('.') + 1
                        ) === 'pdf' ? (
                            <div className="licenseImageContainer">
                                <a target="_blank" href={value?.statement?.bank_statement} rel="noopener noreferrer">
                                    <FileTextOutlined /> bank-statement.pdf
                                </a>
                            </div>
                        ) : (
                            <div className="licenseImageContainer">
                                <img
                                    className="licensePreviewImage"
                                    src={value?.statement?.bank_statement}
                                    alt="License"
                                    style={{ maxHeight: '200px', width: 'auto' }}
                                />
                            </div>
                        ),
                    ]}
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                    className="horizontal-container-element"
                >
                    <label style={{ display: 'block' }}>Credit/Debit Statement</label>
                    {editBankStatement && (
                        <Controller
                            name="card_statement"
                            as={
                                <Upload
                                    style={{ width: '100%' }}
                                    {...creditStatementPickerProps}
                                    accept="image/*,.pdf"
                                    multiple={false}
                                >
                                    <Button disabled={disableCreditStatement}>
                                        <UploadOutlined /> Select credit/debit statement
                                    </Button>
                                </Upload>
                            }
                            control={control}
                            onChange={([data]) => {
                                return data.file;
                            }}
                            rules={{ required: value.statement === null ? true : false }}
                        />
                    )}

                    {errors.card_statement && (
                        <span className="formFieldError">Please select credit/debit statement.</span>
                    )}

                    {value?.statement !== null && [
                        value?.statement?.card_statement.substr(
                            value?.statement?.card_statement.lastIndexOf('.') + 1
                        ) === 'pdf' ? (
                            <div className="licenseImageContainer">
                                <a target="_blank" href={value?.statement?.card_statement} rel="noopener noreferrer">
                                    <FileTextOutlined /> credit-debit-statement.pdf
                                </a>
                            </div>
                        ) : (
                            <div className="licenseImageContainer">
                                <img
                                    className="licensePreviewImage"
                                    src={value?.statement?.card_statement}
                                    alt="License"
                                    style={{ maxHeight: '200px', width: 'auto' }}
                                />
                            </div>
                        ),
                    ]}

                    {/* {value.statement !== null && (
            <div className="licenseImageContainer">
              <img
                className="licensePreviewImage"
                src={value?.statement?.card_statement}
                alt="License"
              />
            </div>
          )} */}
                </Col>
            </Row>

            {editBankStatement && value?.statement !== null && (
                <MuiButton type="submit" className="secondary-btn profileNext">
                    UPDATE
                </MuiButton>
            )}

            <div className="clearfix"></div>
            <br />

            <div className="payment-information-label-container">
                <FileTextOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                <h4 className="payment-information-label">Other loans and debts</h4>
                {value?.loans?.length !== 0 && (
                    <Button
                        id="edit-loans-debit"
                        style={{ float: 'right' }}
                        type="default"
                        icon={editLoan ? <CloseOutlined /> : <EditOutlined />}
                        size="middle"
                        onClick={() => handleEdit(EDIT_LOAN)}
                    />
                )}
            </div>

            <Row className="horizontal-container">
                <Button
                    disabled={disableLoanAdd ? disableLoanAdd : !editLoan}
                    style={{ marginTop: 10, marginLeft: 10, float: 'right' }}
                    className="formAddField"
                    icon={<PlusOutlined />}
                    shape="round"
                    onClick={() =>
                        loanFieldArray.append({
                            loan_id: undefined,
                            loan_type: undefined,
                            lender: undefined,
                            current_payment: undefined,
                            monthly_payment: undefined,
                        })
                    }
                >
                    Add New
                </Button>
            </Row>
            <div className="loanContainer">
                {loanFieldArray.fields.map((item, index) => {
                    return (
                        <Row key={item.id} className="horizontal-container">
                            <Col className="horizontal-container-element removeLoan">
                                <YFinput
                                    disabled={editLoan}
                                    register={register({ required: false })}
                                    label={'Loan Type'}
                                    defaultValue={item.loan_type}
                                    name={`loans[${index}].loan_type`}
                                    placeholder="Enter Loan Type"
                                />
                                <div className="form-error">
                                    {errors?.loans?.[index]?.loan_type && (
                                        <span className="formFieldError">Please enter loan type.</span>
                                    )}
                                </div>
                            </Col>
                            <Col className="horizontal-container-element">
                                <YFinput
                                    disabled={editLoan}
                                    register={register({ required: false })}
                                    label={'Lender'}
                                    defaultValue={item.lender}
                                    name={`loans[${index}].lender`}
                                    placeholder="Enter Lender"
                                />
                                <div className="form-error">
                                    {errors?.loans?.[index]?.lender && (
                                        <span className="formFieldError">Please enter lender.</span>
                                    )}
                                </div>
                            </Col>
                            <Col className="horizontal-container-element removeLoan">
                                <YFinput
                                    disabled={editLoan}
                                    register={register({ required: false })}
                                    label={'Current Balance (MMK)'}
                                    defaultValue={item.current_payment}
                                    name={`loans[${index}].current_payment`}
                                    placeholder="Enter balance"
                                />
                                <div className="form-error">
                                    {errors?.loans?.[index]?.current_payment && (
                                        <span className="formFieldError">Please enter balance.</span>
                                    )}
                                </div>
                            </Col>
                            <Col className="horizontal-container-element removeLoan">
                                <YFinput
                                    disabled={editLoan}
                                    register={register({ required: false })}
                                    label={'Monthly Balance (MMK)'}
                                    defaultValue={item.monthly_payment}
                                    name={`loans[${index}].monthly_payment`}
                                    placeholder="Enter montly payment"
                                />
                                <div className="form-error">
                                    {errors?.loans?.[index]?.monthly_payment && (
                                        <span className="formFieldError">Please enter monthly payment.</span>
                                    )}
                                </div>
                            </Col>
                            <Col className="horizontal-container-element removeLoan">
                                <Fragment>
                                    {/* <Button
                      disabled={!editLoan}
                      style={{ marginTop: 5, marginLeft: 5 }}
                      className="secondary-btn"
                      icon={<UploadOutlined />}
                      shape="circle"
                      onClick={() => handleUpdateLoan({id: item.loan_id, request: item})}
                    ></Button> */}
                                    {index !== 0 && (
                                        <Button
                                            disabled={!editLoan}
                                            style={{ marginTop: 5, marginLeft: 5 }}
                                            className="ant-btn-round formDeleteField"
                                            icon={<DeleteOutlined />}
                                            shape="circle"
                                            onClick={() => {
                                                if (item.loan_id === '' || item.loan_id === undefined) {
                                                    loanFieldArray.remove(index);
                                                } else {
                                                    deleteLoan({ token, id: item.loan_id }).then((response) => {
                                                        loanFieldArray.remove(index);
                                                        profileStore.reload(token);
                                                        message.success(response?.message);
                                                    });
                                                }
                                            }}
                                        >
                                            Delete Loan
                                        </Button>
                                    )}
                                </Fragment>
                            </Col>
                        </Row>
                    );
                })}
            </div>
            <br />
            {editLoan && value?.loans.length > 0 && (
                <MuiButton type="submit" className="secondary-btn profileNext">
                    UPDATE
                </MuiButton>
            )}
            <div className="clearfix"></div>
            <br />
            <div className="payment-information-label-container">
                <FileTextOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                <h4 className="payment-information-label">Monthly living Expense</h4>
                {value.livingExpense !== null && (
                    <Button
                        id="edit-monthly-living"
                        style={{ float: 'right' }}
                        type="default"
                        icon={editMonthlyExpense ? <CloseOutlined /> : <EditOutlined />}
                        size="middle"
                        onClick={() => handleEdit(EDIT_MONTHLY_EXPENSE)}
                    />
                )}
            </div>
            <Row className="horizontal-container">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 6 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={editMonthlyExpense}
                        name="living_expense.general_living"
                        type="number"
                        min="0"
                        step="0"
                        label="General Living (MMK)"
                        placeholder="Enter Genegral Living"
                        register={register({ required: true })}
                    />
                    <div className="form-error">
                        {errors?.living_expense?.general_living && (
                            <span className="formFieldError">Please enter general living.</span>
                        )}
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 6 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={editMonthlyExpense}
                        name="living_expense.rent"
                        type="number"
                        label="Rent (MMK)"
                        placeholder="Enter Rent"
                        register={register({ required: true })}
                    />
                    <div className="form-error">
                        {errors?.living_expense?.rent && <span className="formFieldError">Please enter rent.</span>}
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 6 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={editMonthlyExpense}
                        name="living_expense.utilities"
                        type="number"
                        label="Utilities (MMK)"
                        placeholder="Enter utilities"
                        register={register({ required: true })}
                    />
                    <div className="form-error">
                        {errors?.living_expense?.utilities && (
                            <span className="formFieldError">Please enter utilities.</span>
                        )}
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 6 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                    className="horizontal-container-element"
                >
                    <YFinput
                        disabled={editMonthlyExpense}
                        name="living_expense.others"
                        type="number"
                        label="Other (MMK)"
                        placeholder="Enter other expanses"
                        register={register({ required: false })}
                    />
                    <div className="form-error">
                        {errors?.living_expense?.others && (
                            <span className="formFieldError">Please enter other expenses.</span>
                        )}
                    </div>
                </Col>
            </Row>

            {editMonthlyExpense && value?.livingExpense !== null && (
                <MuiButton type="submit" className="secondary-btn profileNext">
                    UPDATE
                </MuiButton>
            )}
            <div className="clearfix"></div>
            <br />
            <div className="payment-information-label-container">
                <FileTextOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                <h4 className="payment-information-label">Customer contact details</h4>
                {value?.relationships?.length !== 0 && (
                    <Button
                        id="edit-contact-info"
                        style={{ float: 'right' }}
                        type="default"
                        icon={editContactDetail ? <CloseOutlined /> : <EditOutlined />}
                        size="middle"
                        onClick={() => handleEdit(EDIT_CONTACT_DETAIL)}
                    />
                )}
            </div>

            <Row className="horizontal-container">
                <Button
                    disabled={!editContactDetail}
                    style={{ marginTop: 10, marginLeft: 10, float: 'right' }}
                    className="formAddField"
                    icon={<PlusOutlined />}
                    shape="round"
                    onClick={() =>
                        contactDetailFieldArray.append({
                            fullname: '',
                            address: '',
                            contact_number: '',
                            relationship_type: undefined,
                        })
                    }
                >
                    Add New
                </Button>
            </Row>

            <div className="loanContainer">
                {contactDetailFieldArray.fields.map((item, index) => {
                    return (
                        <Row key={item.id} className="horizontal-container">
                            <Col className="horizontal-container-element">
                                <YFinput
                                    disabled={editContactDetail}
                                    register={register({ required: true })}
                                    label={'Full Name'}
                                    defaultValue={item.fullname}
                                    name={`relationship[${index}].fullname`}
                                    placeholder="Enter Full Name"
                                />
                                {
                                    <div className="form-error">
                                        {errors?.relationship?.[index]?.fullname && (
                                            <span className="formFieldError">Please enter full name.</span>
                                        )}
                                    </div>
                                }
                            </Col>
                            <Col className="horizontal-container-element">
                                <YFinput
                                    disabled={editContactDetail}
                                    register={register({ required: true })}
                                    label={'Residential Address'}
                                    defaultValue={item.address}
                                    name={`relationship[${index}].address`}
                                    placeholder="Enter Residential Address"
                                />
                                <div className="form-error">
                                    <div className="form-error">
                                        {errors?.relationship?.[index]?.address && (
                                            <span className="formFieldError">Please enter address.</span>
                                        )}
                                    </div>
                                </div>
                            </Col>
                            <Col className="horizontal-container-element">
                                {/* {index === 0 && (
                  <label style={{ display: "block" }}>Type</label>
                )} */}
                                {/* <Controller
                  name={`relationship[${index}].relationship_type`}
                  as={
                    <Select
                      showSearch
                      disabled={!editContactDetail}
                      className="yf-select"
                      style={{ width: "100%" }}
                      placeholder="Select"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {RelationshipType.map((item) => {
                        return (
                          <Option value={item.value} key={item.id}>
                            {item.label}
                          </Option>
                        );
                      })}
                    </Select>
                  }
                  onChange={([selected]) => {
                    return selected;
                  }}
                  rules={{ required: true }}
                  control={control}
                /> */}
                                <YFinput
                                    disabled={editContactDetail}
                                    register={register({ required: true })}
                                    label={'Relationship Type'}
                                    defaultValue={item.relationship_type}
                                    name={`relationship[${index}].relationship_type`}
                                    placeholder="Enter Relationship Type"
                                />
                                {errors?.relationship?.[index]?.relationship_type && (
                                    <span className="formFieldError">Please enter relationship type.</span>
                                )}
                            </Col>

                            <Col className="horizontal-container-element">
                                <YFinput
                                    type="number"
                                    disabled={editContactDetail}
                                    register={register({ required: true })}
                                    label={'Contact Number'}
                                    defaultValue={item.contact_number}
                                    name={`relationship[${index}].contact_number`}
                                    placeholder="Enter Contaact Number"
                                />
                                <div className="form-error">
                                    <div className="form-error">
                                        {errors?.relationship?.[index]?.contact_number && (
                                            <span className="formFieldError">Please enter contact number.</span>
                                        )}
                                    </div>
                                </div>
                            </Col>

                            {index !== 0 && index !== 1 && (
                                <Col className="horizontal-container-element">
                                    <Button
                                        disabled={!editContactDetail}
                                        style={{ marginTop: 10, marginLeft: 10 }}
                                        className="ant-btn-round formDeleteField"
                                        icon={<DeleteOutlined />}
                                        shape="circle"
                                        onClick={() => {
                                            if (item.relationship_id === undefined) {
                                                contactDetailFieldArray.remove(index);
                                            } else {
                                                deleteRelationship({
                                                    token,
                                                    id: item.relationship_id,
                                                }).then((response) => {
                                                    contactDetailFieldArray.remove(index);
                                                    profileStore.reload(token);
                                                });
                                            }
                                        }}
                                    >
                                        Delete Loan
                                    </Button>
                                </Col>
                            )}
                        </Row>
                    );
                })}
            </div>
            <br />
            {editContactDetail && value?.relationships.length > 0 && (
                <MuiButton type="submit" className="secondary-btn profileNext">
                    UPDATE
                </MuiButton>
            )}
            {
                <div className="form-error">
                    <div className="form-error">
                        {errors?.relationship && (
                            <span className="formFieldError">{errors?.relationship?.message}</span>
                        )}
                    </div>
                </div>
            }
            <br />
            <br />
            <br />
            {/* {!value?.statement && ( */}
            <MuiButton type="submit" className="secondary-btn profileNext">
                Save
            </MuiButton>
            {/* )} */}
            {/* <div>
        <MuiButton
          type="button"
          className="secondary-btn profilePrev"
          onClick={() => onBack()}
        >
          BACK
        </MuiButton>

        {value.statement === null ? (
          
        ) : (
          <MuiButton
            type="button"
            className="secondary-btn profileNext"
            onClick={() => onNext()}
          >
            NEXT
          </MuiButton>
        )}
      </div> */}
        </form>
    );
};

DeclarationForm.propTypes = {
    token: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
};

// const RelationshipType = [
//   {
//     label: "Father",
//     value: "Father",
//   },
//   {
//     label: "Mother",
//     value: "Mother",
//   },
//   {
//     label: "Brother",
//     value: "Brother",
//   },
//   {
//     label: "Sister",
//     value: "Sister",
//   },
//   {
//     label: "Son",
//     value: "Son",
//   },
//   {
//     label: "Daughter",
//     value: "Daughter",
//   },
//   {
//     label: "Friend",
//     value: "Friend",
//   },
//   {
//     label: "GrandFather",
//     value: "GrandFather",
//   },
//   {
//     label: "GrandMother",
//     value: "GrandMother",
//   },
//   {
//     label: "GrandSon",
//     value: "GrandSon",
//   },
//   {
//     label: "GrandDaughter",
//     value: "GrandDaughter",
//   },
//   {
//     label: "Uncle",
//     value: "Uncle",
//   },
//   {
//     label: "Aunt",
//     value: "Aunt",
//   },
//   {
//     label: "Father In Law",
//     value: "Father In Law",
//   },
//   {
//     label: "Mother In Law",
//     value: "Mother In Law",
//   },
//   {
//     label: "Brother In Law",
//     value: "Brother In Law",
//   },
//   {
//     label: "Sister In Law",
//     value: "Sister In Law",
//   },
//   {
//     label: "Husband",
//     value: "Husband",
//   },
// ];

export default DeclarationForm;
